module.exports = __webpack_public_path__ + "static/assets/b9a9cd7aa9f7aa156502d9d29ab39701.png";